var map = {
	"./core": 326,
	"./core.js": 326,
	"./event": 328,
	"./event.js": 328,
	"./fake_server": 329,
	"./fake_server.js": 329,
	"./fake_server_with_clock": 330,
	"./fake_server_with_clock.js": 330,
	"./fake_timers": 331,
	"./fake_timers.js": 331,
	"./fake_xdomain_request": 333,
	"./fake_xdomain_request.js": 333,
	"./fake_xml_http_request": 334,
	"./fake_xml_http_request.js": 334,
	"./timers_ie": 335,
	"./timers_ie.js": 335,
	"./xdr_ie": 336,
	"./xdr_ie.js": 336,
	"./xhr_ie": 337,
	"./xhr_ie.js": 337
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib/sinon/util ^\.\/.*$
// module id = 327
// module chunks = 1